const URLS = {
  V1: "https://stagapi.orbitshift.ai/v1",
  ASSETS: "https://stagapi.orbitshift.ai/assets",
  OS_LITE: "https://stagapi.orbitshift.ai/v1/os_lite"
}

export default URLS
